<template lang="pug">
div
    BaseHeader(titulo='Configuração da Rastreabilidade')
    .bloco-content
        .bloco-acessos
            .acesso(
                v-for='(menu, index) in menus',
                :key='`menu-acesso-${index}`',
                :class='menu.ativo ? "ativo allowed" : "inativo not-allowed"'
            )
                .acesso__info
                    i.acesso__icone(:class='menu.icone') {{ menu.conteudo }}
                    .acesso__titulo {{ menu.titulo }}
                .acesso__btn-area
                    button.acesso__btn(@click='goTo(menu.rota, menu.ativo)') {{ menu.tituloBotao }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import { mapGetters } from 'vuex';

export default {
    name: 'ConfiguracaoRastreabilidade',
    components: {
        BaseHeader
    },
    computed: {
        ...mapGetters(['usuarioLogado']),
        isBunge() {
            return this.usuarioLogado.isBunge;
        },
        acessoParametros() {
            return (
                this.usuarioLogado?.rolesAtributosPorGrupo?.[0]?.attributes
                    ?.acesso_parametros || {}
            );
        }
    },
    data() {
        return {
            menus: []
        };
    },
    created() {
        this.menus = this.getMenu();
    },
    methods: {
        goTo(rota, ativo) {
            if (rota && ativo) {
                this.$router.push({ name: rota });
            }
        },
        getMenu() {
            let acesso = [];

            // Verifica se acessoParametros é um array com ao menos um item
            if (
                Array.isArray(this.acessoParametros) &&
                this.acessoParametros.length > 0
            ) {
                acesso = this.acessoParametros[0].split(',').map(c => c.trim());
            }

            const todosMenus = [
                {
                    icone: 'lyra-icon lyra-mapa',
                    titulo: 'Regional',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoRegionais',
                    codigo: 'CONFIGURACAO_REGIONAIS'
                },
                {
                    icone: 'lyra-icon lyra-user',
                    titulo: 'Gerentes Regionais',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'GerentesRegionais',
                    codigo: 'CONFIGURACAO_GERENTES_REGIONAIS'
                },
                {
                    icone: 'lyra-icon lyra-multiple-account-outline',
                    titulo: 'Gerentes Comerciais',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoGerentesComerciais',
                    codigo: 'CONFIGURACAO_GERENTES_COMERCIAIS'
                },
                {
                    icone: 'lyra-icon lyra-home',
                    titulo: 'Gerentes Territoriais',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoGerentesTerritoriais',
                    codigo: 'CONFIGURACAO_GERENTES_TERRITORIAIS'
                },
                {
                    icone: 'lyra-icon lyra-van',
                    titulo: 'Fornecedores',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoFornecedores',
                    codigo: 'CONFIGURACAO_FORNECEDORES'
                },
                {
                    icone: 'el-icon el-icon-box',
                    titulo: 'Material',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoMaterial',
                    codigo: 'CONFIGURACAO_MATERIAL'
                },
                {
                    icone: 'lyra-icon lyra-star',
                    titulo: 'Segmento',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoSegmentos',
                    codigo: 'CONFIGURACAO_SEGMENTOS'
                },
                {
                    icone: 'el-icon el-icon-setting',
                    titulo: 'Parâmetros',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoParametros',
                    codigo: 'CONFIGURACAO_PARAMETROS'
                },
                {
                    icone: 'material-symbols-outlined',
                    conteudo: 'factory',
                    titulo: 'Planta',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'ConfiguracaoPlanta',
                    codigo: 'CONFIGURACAO_PLANTA'
                },
                {
                    icone: 'material-symbols-outlined',
                    conteudo: 'supervisor_account',
                    titulo: 'Especialista',
                    tituloBotao: 'Acessar',
                    ativo: true,
                    rota: 'Especialistas',
                    codigo: 'CONFIGURACAO_ESPECIALISTA'
                }
            ];

            // Se acesso estiver vazio, retorna todos os menus
            if (acesso.length === 0) {
                return todosMenus;
            }

            // Senão, retorna apenas os menus permitidos
            return todosMenus.filter(menu => acesso.includes(menu.codigo));
        }
    }
};
</script>

<style lang="scss">
.bloco-content {
    margin-top: 30px;
    display: flex;
    padding: 0 40px;
    justify-content: center;
    width: 100%;
}
.bloco-acessos {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    width: 100%;
    @media only screen and (min-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media only screen and (min-width: 1260px) {
        grid-template-columns: repeat(4, 1fr);
    }
}

.acesso {
    width: 100%;
    border-radius: $default-border-radius;
    background-color: $white;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    padding: 25px 35px;
    gap: 30px;
}

.inativo {
    background-color: #ccc;
}

.allowed {
    cursor: default;
}

.not-allowed {
    cursor: not-allowed;
}

.acesso.ativo:hover {
    background-color: var(--primary);
}

.acesso.ativo:hover .acesso__titulo {
    color: $white;
}

.acesso.ativo:hover .acesso__btn {
    color: var(--primary);
    background-color: $white;
}

.acesso__btn:hover {
    cursor: pointer;
}

.acesso__info {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 30px;
}

.acesso__icone {
    flex: 1;
}

.acesso__icone.lyra-icon.lyra-mapa::before,
.acesso__icone.lyra-icon.lyra-user::before,
.acesso__icone.lyra-icon.lyra-multiple-account-outline::before,
.acesso__icone.lyra-icon.lyra-home::before,
.acesso__icone.lyra-icon.lyra-van::before,
.acesso__icone.lyra-icon.lyra-star::before {
    background-color: #ddac44;
}

.el-icon.el-icon-box,
.el-icon.el-icon-setting,
.material-symbols-outlined {
    color: #ddac44 !important;
    font-size: 50px;
}

.acesso__icone.lyra-icon.lyra-mapa::before {
    width: 50px;
    height: 50px;
}

.acesso__icone.lyra-icon.lyra-user::before {
    width: 50px;
    height: 60px;
}

.acesso__icone.lyra-icon.lyra-multiple-account-outline {
    width: 80px;
    height: 80px;
}

.acesso__icone.lyra-icon.lyra-multiple-account-outline::before {
    width: 90px;
    height: 90px;
    display: flex;
    align-items: flex-end;
    position: relative;
    right: 14px;
}

.acesso__icone.lyra-icon.lyra-home::before {
    width: 50px;
    height: 54px;
}

.acesso__icone.lyra-icon.lyra-van::before,
.acesso__icone.lyra-icon.lyra-star::before {
    width: 60px;
    height: 60px;
}

.acesso__titulo {
    flex: 2;
    font-size: 18px;
    font-weight: bold;
    color: var(--primary);
}

.acesso__btn-area {
    width: 100%;
}

.acesso__btn {
    display: block;
    width: 100%;
    padding: 8px;
    background-color: var(--primary);
    color: $white;
    border-radius: $default-border-radius;
    border: 0;
    outline: none;
}

.acesso.not-allowed .acesso__btn:hover {
    cursor: not-allowed;
}

.acesso__btn:focus {
    outline: none;
}
</style>
